import { API_URL } from "config";
import Http from "util/https";
import { downloadFromUrl } from "../utils/common";

/**
 * ダウンロードするURLを取得
 * @param supplierCd 仕入先コード
 */
export default async function downloadThresholdCsvUrl(supplierCd: string) {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/stock/setting/csv/download`;
  const res = await http.post(url, {code: supplierCd});

  downloadFromUrl(res.data.url, '設定値データ');

  return res.data;
}